import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        flex: "1 1 0",
        minWidth: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        "& .MuiListItemButton": {
            minHeight: 40,
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            "&:hover": {
                "& .MuiTypography-root": { color: theme.palette.emteria.text.primary },
                "& i": { color: theme.palette.emteria.text.primary },
            },
            "&.Mui-selected": {
                "& .MuiTypography-root": { color: theme.palette.emteria.text.inverse },
                "& i": { color: theme.palette.emteria.text.inverse },
            },
            "&.Mui-selected:hover": {
                "& .MuiTypography-root": { color: theme.palette.emteria.text.primary },
                "& i": { color: theme.palette.emteria.text.primary },
            },
        },
    },
    navText: {
        fontSize: 14,
        color: theme.palette.emteria.text.primary,
    },
    workspaceItem: {
        paddingLeft: theme.spacing(2),
    },
    expandIcon: {
        width: 24,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    folderIcon: {
        marginRight: theme.spacing(1),
        fontSize: 14,
        color: theme.palette.emteria.text.primary,
    },
    listItemText: {
        margin: 0,
        "& .MuiTypography-root": { flexGrow: 1 },
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(1, 2),
        borderBottom: `1px solid ${theme.palette.emteria.border.primary}`,
        flexShrink: 0,
    },
    toolbarNoExpand: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(1, 1),
        borderBottom: `1px solid ${theme.palette.emteria.border.primary}`,
        flexShrink: 0,
    },
    treeList: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
    },
    treeRowBg: {
        "&&:hover": {
            backgroundColor: theme.palette.emteria.background.navigationHover,
        },
        "&&.Mui-selected": {
            backgroundColor: theme.palette.emteria.background.navigationHover,
        },
        "&&.Mui-selected:hover": {
            backgroundColor: theme.palette.emteria.background.navigationHover,
        },
    },
    expandIconVisible: {
        visibility: "visible" as const,
    },
    expandIconHidden: {
        visibility: "hidden" as const,
    },
    chevronIcon: {
        fontSize: 10,
    },
    toggleAllIcon: {
        fontSize: 14,
    },
    workspaceIcon: {
        marginRight: theme.spacing(1),
        fontSize: 14,
        color: theme.palette.emteria.text.primary,
    },
}));
